export const GA_CATEGORY_TYPE = {
	MOBILE_TOP_NAVBAR: 'mobileTopNavbar',
	DESKTOP_TOP_NAVBAR: 'desktopTopNavbar',
	SIDE_NAVBAR: 'sideNavbar',
};

export const GA_ACTION_TYPE = {
	USER_CLICK: 'userClick',
};
